import comp from "./AssignClassSettingsDataGrid";
export default comp;
